export default "__VITE_ASSET__Cr769C7e__"